import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class TowerService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Tower/GetAll", { params })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Tower/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post("api/services/app/Tower/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Tower/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(params?: any): Promise<any> {
    const res = await http.get("api/services/app/Tower/GetList", { params })
    const { result } = res.data
    return result
  }
  public async exportExcel(params: any, name: any = "tower"): Promise<any> {
    const res = await http.get("api/Export/ExportTower", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `${name || "EXPORT-TOWER"}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  public async importTower(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportTower", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }

  /**
   * Tải tệp Excel theo khuôn import của Tower.
   *
   * Phải gọi controller `api/Export/ExportTower` (trả `File(...)` thật, dựng từ
   * `Export-Tower.xlsx` + `TowerAppService.ExportForImportAsync`). Bản cũ gọi
   * `api/services/app/Tower/Export` — dynamic API đó trả `List<ExportDto>` là JSON, nên tệp `.xlsx`
   * tải về có ruột JSON và Excel báo sai định dạng (cùng lỗi với BUG-0386).
   */
  public async exportTemplateTower(): Promise<any> {
    const res = await http.get("api/Export/ExportTower", {
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-TOWER-TEMPLATE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
}

export default new TowerService()
